export default __webpack_public_path__ + "static/media/16-InifinityCar-Logo.96ad2011.jpg";